import React from 'react';
import {ActionableNotification, Button, FeatureFlags} from '@carbon/react';
import classNames from '../../../../lib/class-names';
import './roster-list-error.scss';

export type Props = {
    // What the failure means for the view it is shown in
    body: string;
    onRetry: () => void;
    // Off for a second copy of a failure another view already announces: it is then a group named
    // by its title rather than an alert, so a screen reader does not read the failure out twice
    announce?: boolean;
    className?: string;
    'data-testid'?: string;
};

/**
 * The roster list failed to load: Carbon's low-contrast inline error notification, with a retry
 *
 * ActionableNotification, not InlineNotification: Carbon forbids interactive children in the inline
 * one. role='alert' (not the default 'alertdialog') so it neither steals focus nor traps Tab, and the
 * flag drops the focus-trap sentinels that would otherwise be two empty tab stops. The retry is a
 * child rather than actionButtonLabel, which would render a ghost button beside the text instead of
 * the tertiary one under it.
 */
const RosterListError = ({body, onRetry, announce = true, className, 'data-testid': testId}: Props) => (
    <FeatureFlags enableExperimentalFocusWrapWithoutSentinels>
        <ActionableNotification
            inline
            kind='error'
            lowContrast
            hideCloseButton
            role={announce ? 'alert' : 'group'}
            title={'Couldn’t load rosters'}
            subtitle={body}
            className={classNames('roster-list-error', className)}
            data-testid={testId}
        >
            <Button kind='tertiary' size='sm' className='roster-list-error__retry' onClick={onRetry}>
                Try again
            </Button>
        </ActionableNotification>
    </FeatureFlags>
);

export default RosterListError;
